import React from 'react';
import "./Card.scss";
import { Link } from 'react-router-dom';

const Card = ({ image, name, occupation, price }) => {
    return (
        <div className="card">
            <div className="card__image-container">
                <img src={image} alt="Person" />
            </div>
            <div className="card__prestige">
                <span className="card__stars">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                </span>
                <span className="card__occupation">
                    {occupation}
                </span>
            </div>
            <div className="card__data">
                <span className="card__name">
                    {name}
                </span>
                <span className="card__price">
                    ${price}
                </span>
            </div>
            <div className="card__description">
                <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Qui nihil pariatur laudantium a expedita nemo repellat atque consequatur temporibus provident.</p>
            </div>
            <div className="card__button-container">
                <Link className="card__button" to={{
                    pathname: 'prestador/perfil',
                    state: {
                        image: image,
                        name: name,
                        occupation: occupation,
                        price: price
                    }
                }}>VER PERFIL</Link>
            </div>
        </div>
    )
}

export default Card;
